import { ref, computed, watch } from 'vue'
import { getRegionLevelAttr } from '../helpers/DanmarksKortMap.helpers.js'

export function useAccessibilityList(props, deps) {
  const { activeRegionGroups, setHover, clearHover, showTooltipAtSvgCentroid, goBack, tooltip } = deps

  const listRef      = ref(null)
  const focusedIndex = ref(0)

  watch(activeRegionGroups, () => { focusedIndex.value = 0 })

  const tabIndexes = computed(() =>
    activeRegionGroups.value.map((_, i) => i === focusedIndex.value ? 0 : -1)
  )

  const listLabel = computed(() =>
    props.flow === 'sundhedsraad' ? props.accessibilityListLabelSundhedsraad : props.accessibilityListLabelMunicipality
  )

  const onItemFocus = (index, key) => {
    focusedIndex.value = index
    const groupAttr = getRegionLevelAttr(props.flow)
    if (groupAttr) {
      setHover(groupAttr, key)
      showTooltipAtSvgCentroid(groupAttr, key)
    }
  }

  const onItemBlur = () => {
    clearHover()
    tooltip.value.visible = false
  }

  const onKeydown = (event, currentIndex) => {
    if (event.key === 'Escape') { event.preventDefault(); clearHover(); goBack(); return }

    const count = activeRegionGroups.value.length
    if (!count) return

    let nextIndex = currentIndex
    if      (event.key === 'ArrowDown') { event.preventDefault(); nextIndex = (currentIndex + 1) % count }
    else if (event.key === 'ArrowUp')   { event.preventDefault(); nextIndex = (currentIndex - 1 + count) % count }
    else if (event.key === 'Home')      { event.preventDefault(); nextIndex = 0 }
    else if (event.key === 'End')       { event.preventDefault(); nextIndex = count - 1 }
    else return

    focusedIndex.value = nextIndex
    listRef.value?.querySelectorAll('button')[nextIndex]?.focus()
  }

  return {
    regionListRef:      listRef,
    regionListLabel:    listLabel,
    regionListTabIndexes: tabIndexes,
    onRegionListItemFocus: onItemFocus,
    onRegionListItemBlur:  onItemBlur,
    onRegionListKeydown:   onKeydown,
  }
}
